import classes, { CommandsManager, HotkeysManager } from './classes';
import IWebApiDataSource from './DataSources/IWebApiDataSource';
import DICOMWeb from './DICOMWeb';
import defaults from './defaults';
import * as Enums from './enums';
import errorHandler from './errorHandler';
import { ExtensionManager, MODULE_TYPES } from './extensions';
import { useToolbar } from './hooks';
import log from './log';
import object from './object';
import {
	CustomizationService,
	DicomMetadataStore,
	DicomPrintService,
	DisplaySetService,
	HangingProtocolService,
	MeasurementService,
	PanelService,
	PubSubService,
	pubSubServiceInterface,
	ServiceProvidersManager,
	ServicesManager,
	SessionAuthenticationService,
	StudyPrefetcherService,
	ToolbarService,
	UIDialogService,
	UIModalService,
	UINotificationService,
	UIViewportDialogService,
	ViewportGridService,
	WorkflowStepsService,
} from './services';
import { DisplaySetMessage, DisplaySetMessageList } from './services/DisplaySetService';
import string from './string';
import * as Types from './types';
import user from './user';
import utils from './utils';

export * from './contextProviders';

const hotkeys = {
	...utils.hotkeys,
	defaults: { hotkeyBindings: defaults.hotkeyBindings },
};

const Core = {
	MODULE_TYPES,
	//
	CommandsManager,
	ExtensionManager,
	HotkeysManager,
	ServicesManager,
	ServiceProvidersManager,
	//
	defaults,
	utils,
	hotkeys,
	classes,
	string,
	user,
	errorHandler,
	object,
	log,
	DICOMWeb,
	viewer: {},
	//
	CustomizationService,
	UIDialogService,
	UIModalService,
	UINotificationService,
	UIViewportDialogService,
	DisplaySetService,
	MeasurementService,
	ToolbarService,
	ViewportGridService,
	HangingProtocolService,
	SessionAuthenticationService,
	IWebApiDataSource,
	DicomMetadataStore,
	pubSubServiceInterface,
	PubSubService,
	PanelService,
	useToolbar,
	WorkflowStepsService,
	StudyPrefetcherService,
	DicomPrintService,
};

export {
	//
	//
	CommandsManager,
	CustomizationService,
	DICOMWeb,
	DicomMetadataStore,
	DisplaySetMessage,
	DisplaySetMessageList,
	DisplaySetService,
	Enums,
	ExtensionManager,
	HangingProtocolService,
	HotkeysManager,
	IWebApiDataSource,
	MODULE_TYPES,
	MeasurementService,
	PanelService,
	PubSubService,
	ServiceProvidersManager,
	ServicesManager,
	SessionAuthenticationService,
	StudyPrefetcherService,
	ToolbarService,
	Types,
	UIDialogService,
	UIModalService,
	UINotificationService,
	UIViewportDialogService,
	ViewportGridService,
	WorkflowStepsService,
	DicomPrintService,
	classes,
	//
	defaults,
	errorHandler,
	hotkeys,
	log,
	object,
	pubSubServiceInterface,
	string,
	useToolbar,
	user,
	utils,
};

export type { UtilitiesModule, ViewportModule } from './extensions';
export * from './hooks';
export type * from './services';

export { Core };

export default Core;
